var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bind-success"},[_c('order-card',{attrs:{"payerDisabled":"","orderDisabled":""}}),_c('router-link',{staticClass:"btn-common",attrs:{"to":"/bind_ticket","replace":""}},[_vm._v("切换船票")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }